import React from "react";
import ServicesList from "../reusables/ServicesList";

const ServicesBody = () => {
  return (
    <section className="section section-spacing-100 no-padding-bottom">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="section-body section-spacing-20">
              <ServicesList />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesBody;

{
  /*




<div className="services-container width-600 margin-auto">
              <ul>
                <li>
                  <h3>1. HDPE welding</h3>
                  <p>
                    At JMSTONE, we pride ourselves in delivering top-quality
                    HDPE welding that meet the highest standard of performance
                    and durability in line with the industry standards. We offer
                    exceptional HDPE welding service, ensuring that every seam
                    is precision-crafted to last.
                  </p>
                  <p>
                    Our expert welders use latest welding techniques, utilizing
                    state-of-the-art equipment to create impermeable seams that
                    comply with industry standards. We employ advanced methods
                    such as:
                  </p>
                  <ul>
                    <li>• Fusion Welding for HDPE Liner </li>
                    <li>• Extrusion welding for HDPE repairs </li>
                    <li>
                      • Hot gas welding for tacking and Reinforced Vinyl Tank
                      Construction{" "}
                    </li>
                    <li>• Welding and assembling inflatable HDPE tanks </li>
                    <li>• Butt fusion 1 inch to 12.40 inches </li>
                  </ul>
                  <p>
                    To ensure that all welds meet or exceed industry standards,
                    several testing methods are employed and Include:
                    Destructive Testing, Non-Destructive Testing, Visual
                    Inspection and Hydrostatic Testing.{" "}
                  </p>
                </li>
                <li>
                  <h3>2. Earth Works </h3>
                  <p>
                    WE also undertake the associated Geosynthetics and HDPE pipe
                    installation earthworks.
                  </p>
                </li>
                <li>
                  <h3>3. NDT Welding Inspection </h3>
                  <p>
                    Non-Destructive Testing (NDT) welding inspection services
                    are crucial for ensuring the quality and safety of welded
                    structures without causing damage to the components being
                    inspected. The methods JMSTONE uses in HDPE welding
                    inspection include: 1) Visual Inspection, 2) Air Pressure
                    Testing, 3) Vacuum Air Pressure Testing, and 4) Air Spark
                    Testing.
                  </p>
                  <p>
                    These methods help ensure that welds meet industry standards
                    and specifications, providing confidence in the integrity
                    and safety of the welded structures.
                  </p>
                </li>
                <li>
                  <h3>4. Tent/tarpaulin making and repairing </h3>
                  <p>
                    JMSTONE LOGISTICS has extended its range of services by
                    offering specialized tent and tarpaulin making services. We
                    also provide repair services to fix holes and tears, seam
                    repairs, zipper replacements and leak proofing.
                  </p>
                </li>
                <li>
                  <h3>5. Repair and maintenance </h3>
                  <p>
                    We understand that even the most durable geomembrane liners
                    require periodic maintenance and occasional repairs to
                    ensure optimal performance and extend their lifespan.
                  </p>
                  <p>
                    That’s why we offer expert repair and maintenance services
                    to our clients, designed to safeguard your liner, and the
                    environment from any possible leaks.
                  </p>
                  <p>
                    Our team of skilled technicians and welders are equipped to
                    detect and repair any damage, from minor punctures to
                    extensive tears.
                  </p>
                </li>
              </ul>
            </div>








*/
}
